import { curry, pathOr } from 'ramda';

import { categoryIcons } from './constants';

export const getCategiryIcon = curry((league, subject) => pathOr('N/A', [league, subject, 'primary'], categoryIcons));
